export default{
  methods: {
    isValidLatLong: function (lat, lng) {
      return lat && lng && this.isValidLatitude(lat) && this.isValidLongitude(lng)
    },
    isValidLatitude: (lat) => {
      return lat >= -90.0 && lat <= 90.0
    },
    isValidLongitude: (lng) => {
      return lng >= -180.0 && lng <= 180.0
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/widgets/geo-mixin.js